/**
 * A save response may carry a nudge picked at event time (`journey` on the PUT response). The API
 * client strips it from the cached entry and publishes it here; the JourneyBridge (mounted under
 * the toast provider) listens and shows it. A plain window event keeps the data layer free of any
 * React provider requirement.
 */
import type { JourneySurface, WireNudge } from '../../../types/journey';

export const JOURNEY_NUDGE_EVENT = 'jc:journey-nudge';

export interface JourneyNudgeDetail {
  nudge: WireNudge;
  surface: JourneySurface;
}

/** Removes `journey` from a PUT response body and publishes it. Always returns the body without it. */
export function takeJourneyFromResponse<T>(body: T): T {
  if (!body || typeof body !== 'object' || !('journey' in (body as Record<string, unknown>))) return body;
  const { journey, ...rest } = body as Record<string, unknown> & { journey?: Partial<JourneyNudgeDetail> };
  if (journey?.nudge && journey.surface && typeof window !== 'undefined') {
    try {
      window.dispatchEvent(new CustomEvent<JourneyNudgeDetail>(JOURNEY_NUDGE_EVENT, { detail: { nudge: journey.nudge, surface: journey.surface } }));
    } catch {
      // A nudge never breaks a save.
    }
  }
  return rest as T;
}
